function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#262223"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.12 0h3.75A1.13 1.13 0 0124 1.13v3.75A1.13 1.13 0 0122.88 6h-3.75A1.13 1.13 0 0118 4.88V1.12A1.12 1.12 0 0119.12 0zM1.13 15h12.75A1.13 1.13 0 0015 13.88V1.13A1.12 1.12 0 0013.89 0H1.13A1.12 1.12 0 000 1.11v12.77A1.13 1.13 0 001.13 15z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 9,
  width: 6,
  height: 6,
  rx: 1.13,
  ry: 1.13
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.12 18h3.76A1.12 1.12 0 016 19.12v3.75A1.13 1.13 0 014.88 24H1.12A1.12 1.12 0 010 22.88v-3.75A1.12 1.12 0 011.11 18zM22.88 18H10.13A1.13 1.13 0 009 19.13v3.75A1.13 1.13 0 0010.13 24h12.75A1.13 1.13 0 0024 22.88v-3.75A1.12 1.12 0 0022.89 18z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;